/* ═══════════════════════════════════════════
   ROS — Men's Ritual Care
   ros-custom.js
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  // ── Custom cursor ─────────────────────────
  var cursor = document.getElementById('cursor');
  var ring   = document.getElementById('cursor-ring');
  var mx = 0, my = 0, rx = 0, ry = 0;

  if (cursor && ring) {
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top  = my + 'px';
    });

    function animRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animRing);
    }
    animRing();

    var hoverEls = document.querySelectorAll(
      'a, button, .scent-card, .ingr-card, .pf-image, .ls-half, .nn-card'
    );
    hoverEls.forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        ring.style.width       = '56px';
        ring.style.height      = '56px';
        ring.style.borderColor = 'rgba(200,152,90,0.7)';
      });
      el.addEventListener('mouseleave', function () {
        ring.style.width       = '36px';
        ring.style.height      = '36px';
        ring.style.borderColor = 'rgba(200,152,90,0.4)';
      });
    });
  }

  // ── Hero image zoom in on load ────────────
  var heroImg = document.getElementById('heroImg');
  if (heroImg) {
    setTimeout(function () {
      heroImg.classList.add('loaded');
    }, 80);
  }

  // ── Scroll reveal ─────────────────────────
  var reveals  = document.querySelectorAll('.reveal');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  reveals.forEach(function (el) { observer.observe(el); });

  // ── Hero parallax ─────────────────────────
  var heroContent = document.querySelector('.hero-content');

  window.addEventListener('scroll', function () {
    var sy = window.scrollY;
    var vh = window.innerHeight;

    if (sy < vh) {
      if (heroContent) {
        heroContent.style.transform = 'translateY(' + (sy * 0.25) + 'px)';
        heroContent.style.opacity   = Math.max(0, 1 - sy / (vh * 0.65));
      }
      if (heroImg) {
        heroImg.style.transform = 'translateY(' + (sy * 0.15) + 'px)';
      }
    }
  });

  // ── Nav background on scroll ──────────────
  var nav = document.getElementById('ros-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 80) {
        nav.style.background = 'rgba(10,9,8,0.97)';
      } else {
        nav.style.background = '';
      }
    });
  }

})();
